import { InfoCircleOutlined } from '@ant-design/icons';
import { users } from '@mep/pae-commons';
import { Tag, Tooltip } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { USER_TYPE_APPEARANCE } from '@/modules/admin/contants/user.status';

const { USER_TYPES, USER_TYPES_ENUM } = users;

const UserType = ({ type, full, help, className, icon, ...props }) => {
  const { t } = useTranslation('admin');
  if (!USER_TYPE_APPEARANCE[type])
    return (
      <Tag key={type} className={classNames({ 'w-full': full }, className, 'w-16 text-center')}>
        -
      </Tag>);

  return (
    <Tag
      color={USER_TYPE_APPEARANCE[type].color} key={type}
      className={classNames('table-tag-item', { 'w-full': full }, 'max-w-48 flex justify-center', className)} {...props}>
      <div className={'flex items-center'}>
        {icon}
        <span className={'flex-grow'}>{t(`user.types.${type}`)}</span>
        {help && <Tooltip title={t(`user.types.${type}_HELP`)} className="ml-2">
          <InfoCircleOutlined/>
        </Tooltip>
        }
      </div>
    </Tag>
  );
};

UserType.propTypes = {
  className: PropTypes.string,
  help: PropTypes.bool,
  full: PropTypes.bool,
  type: PropTypes.oneOf(USER_TYPES_ENUM),
  icon: PropTypes.any,
};

UserType.defaultProps = {
  type: USER_TYPES.USER
};

export default memo(UserType);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} type this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} user this is the row instance
 * */
export const renderUserType = (type, user) => {
  return (
    <UserType type={type} user={user}/>
  );
};
